import { PaymentType } from "@authory-packages/core";

export const getPaymentLabel = (type: PaymentType) => {
  switch (type) {
    case PaymentType.ChargebeePaypal:
      return "cb_paypal";
    case PaymentType.ChargebeeStripe:
      return "cb_stripe";
    case PaymentType.ChargebeeApplePay:
      return "cb_appl_pay";
    case PaymentType.ChargebeeGooglePay:
      return "cb_ggl_pay";
    default:
      return type;
  }
};
